/**
 * Capitaliza el texto: primera letra en mayúscula y el resto en minúsculas.
 */
export const capitalize = (text) => {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};